import { defineMessage, defineMessages, MessageDescriptor } from 'react-intl';
import { StreamingTotalKey } from 'fym-shared/src/music24/streaming';

/**
 * The label of each total. The ids of Insights stay where the text is the same, so the native
 * apps keep their translations.
 */
export const streamingTotalLabels: Record<StreamingTotalKey, MessageDescriptor> = {
  streams: defineMessage({ id: 'app.sml.insights.metric.streams', defaultMessage: 'Streams' }),
  listeners: defineMessage({ id: 'app.sml.insights.metric.listeners', defaultMessage: 'Listeners' }),
  followers: defineMessage({ id: 'app.sml.insights.metric.followers', defaultMessage: 'Followers' }),
  subscribers: defineMessage({ id: 'app.sml.streaming.metric.subscribers', defaultMessage: 'Subscribers' }),
  saves: defineMessage({ id: 'app.sml.insights.metric.saves', defaultMessage: 'Saves' }),
  playlistAdds: defineMessage({ id: 'app.sml.insights.metric.playlist_adds', defaultMessage: 'Playlist adds' }),
  monthlyListeners: defineMessage({
    id: 'app.sml.insights.metric.monthly_listeners',
    defaultMessage: 'Monthly listeners',
  }),
  downloads: defineMessage({ id: 'app.sml.streaming.metric.downloads', defaultMessage: 'Downloads' }),
};

/** The texts of the totals row and of its tiles (design a1, b1, f4, f5). */
export const streamingTotalsMessages = defineMessages({
  netEarnings: { id: 'app.sml.streaming.metric.netEarnings', defaultMessage: 'Net earnings' },
  vsPrevious: { id: 'app.sml.streaming.total.vsPrevious', defaultMessage: 'vs {previous}' },
  fromDistributor: { id: 'app.sml.streaming.total.fromDistributor', defaultMessage: '{source} · all stores' },
  fromSources: { id: 'app.sml.streaming.total.fromSources', defaultMessage: '{sources}' },
  fromEarnings: { id: 'app.sml.streaming.total.fromEarnings', defaultMessage: '{source} · {start} – {end}' },
  stopped: { id: 'app.sml.streaming.total.stopped', defaultMessage: 'Stopped {date}' },
  notGiven: {
    id: 'app.sml.streaming.total.notGiven',
    defaultMessage: '— The source does not give this number.',
  },
  dittoNoListeners: {
    id: 'app.sml.streaming.total.dittoNoListeners',
    defaultMessage:
      '— Ditto does not give this number. Connect Spotify for Artists in Catalog to see listeners, saves and followers.',
  },
  noCurrency: {
    id: 'app.sml.streaming.total.noCurrency',
    defaultMessage: 'The source did not say the currency of these amounts.',
  },
  mayGrow: {
    id: 'app.sml.streaming.total.mayGrow',
    defaultMessage: 'Stores report late. The amounts of the newest weeks can still grow.',
  },
  changeNotReliable: {
    id: 'app.sml.streaming.total.changeNotReliable',
    defaultMessage: 'No change for a short period: the newest amounts are not final.',
  },
  noEarnings: { id: 'app.sml.streaming.total.noEarnings', defaultMessage: 'Nothing reported' },
  filtered: {
    id: 'app.sml.streaming.total.filtered',
    defaultMessage: 'Some sources are turned off. The change shows again when all sources are on.',
  },
});
